document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.cstm-collection-slider');

  sections.forEach((section) => {
    const frames = [
      section.querySelector('.cstm-collection-slider__frame--vertical'),
      section.querySelector('.cstm-collection-slider__frame--horizontal'),
    ];

    const slideGroups = [
      ...frames.map((frame) => Array.from(frame.querySelectorAll('.cstm-collection-slider__slide'))),
      Array.from(section.querySelectorAll('.cstm-collection-slider__mobile-slide')),
    ];

    const prevBtn = section.querySelector('.cstm-collection-slider__arrow--prev');
    const nextBtn = section.querySelector('.cstm-collection-slider__arrow--next');
    const titleEl = section.querySelector('.cstm-collection-slider__title');

    // Parse 'true'/'false' string from data attribute, default to false if missing
    const enableLoop = section.dataset.enableLoop === 'true';

    // Find valid slides to determine count
    const firstNonEmptyGroup = slideGroups.find((g) => g.length > 0);
    const totalSlides = firstNonEmptyGroup ? firstNonEmptyGroup.length : 0;

    let currentIndex = 0;
    let isAnimating = false;

    if (totalSlides === 0) return;

    // Get all titles from the first group (vertical frame or mobile)
    const titleSlides = firstNonEmptyGroup || [];
    function updateTitle() {
      if (!titleEl) return;
      const slide = titleSlides[currentIndex];
      if (slide) {
        const title = slide.getAttribute('data-title') || '';
        titleEl.textContent = title;
      } else {
        titleEl.textContent = '';
      }
    }
    updateTitle();

    function updateButtonState() {
      if (enableLoop) return;

      if (prevBtn) {
        prevBtn.classList.toggle('disabled', currentIndex === 0);
        prevBtn.disabled = currentIndex === 0;
      }

      if (nextBtn) {
        nextBtn.classList.toggle('disabled', currentIndex === totalSlides - 1);
        nextBtn.disabled = currentIndex === totalSlides - 1;
      }
    }

    updateButtonState();

    function setSlideState(slide, { zIndex, transform, transition }) {
      slide.style.zIndex = zIndex;
      slide.style.transform = transform;
      slide.style.transition = transition || '';
    }

    function animateSlides(newIndex, direction) {
      if (isAnimating) return;

      if (!enableLoop) {
        if (direction === 'next' && currentIndex >= totalSlides - 1) return;
        if (direction === 'prev' && currentIndex <= 0) return;
      }

      isAnimating = true;

      const duration = 600;
      const outgoingIndex = currentIndex;
      const incomingIndex = newIndex;

      slideGroups.forEach((group) => {
        if (!group[outgoingIndex] || !group[incomingIndex]) return;

        const outgoing = group[outgoingIndex];
        const incoming = group[incomingIndex];

        if (direction === 'next') {
          setSlideState(incoming, { zIndex: 3, transform: 'translateX(100%)', transition: 'none' });
          outgoing.style.zIndex = 2;

          // Force reflow
          void incoming.offsetWidth;

          setSlideState(incoming, {
            zIndex: 3,
            transform: 'translateX(0)',
            transition: `transform ${duration}ms ease`,
          });
        } else {
          setSlideState(incoming, { zIndex: 1, transform: 'translateX(0)', transition: 'none' });
          incoming.style.display = 'block';

          setSlideState(outgoing, {
            zIndex: 3,
            transform: 'translateX(0)',
            transition: `transform ${duration}ms ease`,
          });

          // Force reflow
          void outgoing.offsetWidth;

          setSlideState(outgoing, {
            zIndex: 3,
            transform: 'translateX(100%)',
            transition: `transform ${duration}ms ease`,
          });
        }
      });

      currentIndex = newIndex;
      updateButtonState();
      updateTitle();

      setTimeout(() => {
        isAnimating = false;

        slideGroups.forEach((group) => {
          group.forEach((slide, index) => {
            if (index === currentIndex) {
              setSlideState(slide, { zIndex: 2, transform: 'translateX(0)', transition: '' });
            } else {
              setSlideState(slide, { zIndex: 0, transform: 'translateX(0)', transition: '' });
            }
          });
        });
      }, duration + 50);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        let nextIndex;
        if (enableLoop) {
          nextIndex = (currentIndex + 1) % totalSlides;
        } else {
          nextIndex = currentIndex + 1;
          if (nextIndex >= totalSlides) return;
        }
        animateSlides(nextIndex, 'next');
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        let prevIndex;
        if (enableLoop) {
          prevIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        } else {
          prevIndex = currentIndex - 1;
          if (prevIndex < 0) return;
        }
        animateSlides(prevIndex, 'prev');
      });
    }
  });
});
